export default __webpack_public_path__ + "static/pattern-dbed13e86c8e75c98a805d312fcd4da4.png";